var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSharelinkedinreact = function SvgSharelinkedinreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1276B3",
    d: "m9.75 8.053-.017.027h.017z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1276B3",
    fillRule: "evenodd",
    d: "M2.25 0A2.25 2.25 0 0 0 0 2.25v13.5A2.25 2.25 0 0 0 2.25 18h13.5A2.25 2.25 0 0 0 18 15.75V2.25A2.25 2.25 0 0 0 15.75 0zm.649 6.91h2.684v8.075H2.899zm1.359-3.892c.918 0 1.483.603 1.5 1.396 0 .774-.582 1.395-1.518 1.395h-.017c-.9 0-1.483-.621-1.483-1.395 0-.793.6-1.396 1.518-1.396M12.17 6.72c1.765 0 3.09 1.154 3.09 3.634v4.63h-2.684v-4.32c0-1.087-.388-1.826-1.36-1.826-.74 0-1.183.501-1.377.982-.071.174-.089.41-.089.655v4.509H7.067s.035-7.317 0-8.075H9.75v1.143c.359-.55.996-1.332 2.42-1.332",
    clipRule: "evenodd"
  })));
};
export default SvgSharelinkedinreact;